<template>
  <div class="chart-block">
    <h3>
         <a :href="url" target="_blank"> {{chartName}}</a>
      <span>{{updated}}</span></h3>
    <div id="chart_f" class="chart-box"></div>
  </div>
</template>
<script>
import echarts from "echarts";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import {
  formatDate,
  strToFormatDate,
  strToYeayAndMonth
} from "@/plugins/DateTimeFormater.js";
export default {
  props: {
    chartName: { type: String, default: "新能源厂商排名" }
  },
  data() {
    return {
      url:"#",
      chartOption: {},
      chartId: "new_energy_factory_top",
      updated: "",
      myChart:null
    };
  },
  mounted() {
 
 
    this.chartOption = {
      color: ['#a7def3','#327ed4','#5aa0b3','#3b5b81','##f4eede','#bb3021'],
      //color:['#4ebdea','#a7def3','#327ed4','#5aa0b3','#3b5b81','##f4eede','#bb3021'],
        // color: [  "#32d3eb", "#5bc49f", "#feb64d", "#ff7c7c", "#9287e7"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      legend: {
        data: [],
        right: 30
      },
      grid: {
        left: "3%",
        right: "10%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: "#3b5b81" },
        splitLine: { show: true, lineStyle: { type: "dashed" } },
        label: { show: false }
      },
      yAxis: {
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: "#3b5b81" },
        label: { show: false },
        type: "category",
        data: [ ],
        inverse: true
      },
      series: [
        
      ]
    };
   this.getChartList({handle:this.updateChart});
  },
  methods: {

        ...mapActions("home", ["queryChartConfigs", "queryChartUpdate","getChartList"]),
    updateChart() {
      this.myChart = echarts.init(document.getElementById("chart_f"));
      var info = this.getChartByName(this.chartId);
    //{"factory":"广汽丰田","et":"油电混合动力","sales":"76961"}
   this.url = info.url;
       var json= eval(info.jsonData);
        var factorys = [...new Set(json.map(x=>x.factory))];
        var ets = [...new Set(json.map(x=>x.et))];
        this.chartOption. yAxis.data = factorys;
         this.chartOption.legend.data = ets;
       for(var et of ets)
       {
          var rs=  json.filter(x=>x.et==et);
          var counts =  [...new Set(rs.map(x=>x.sales))];
          
          var serie = { type: "bar", name:et,  stack: "总量",
   
          data:counts
          };
          this.chartOption.series.push(serie);
          
       }
 
      this.myChart.setOption(this.chartOption);
      window.addEventListener("resize", function() {
         this.myChart && this.myChart.resize();
      });
         
      this.updated = `${strToYeayAndMonth(info.lastUpdated)}更新`;
        
       
    }
  },
  watch: {},
  created() {},
  computed: {
    ...mapGetters("home", {
      chartList: "chartList",
      getChartByName: "getChartByName"
    })
  }
};
</script>
 